<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="0" stepTitle="价格与套餐"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">基础信息</span>
            </a-col>
          </a-row>
          <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                        :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol"
          >
            <a-form-model-item label="商品标题" prop="proName">
              <a-input v-model="ruleForm.proName" :maxLength="120" placeholder="建议填写景酒商品名称">
                <span slot="addonAfter">{{ ruleForm.proName.length }}/120</span>
              </a-input>
            </a-form-model-item>
            <a-form-model-item label="产品亮点" prop="ticketHotelStressOne">
              <a-input v-model="ruleForm.ticketHotelStressOne" :maxLength="100" placeholder="请输入商品亮点1"></a-input>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol" prop="ticketHotelStressTwo">
              <a-input v-model="ruleForm.ticketHotelStressTwo" :maxLength="100" placeholder="请输入商品亮点2"></a-input>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol" prop="ticketHotelStressThree">
              <a-input v-model="ruleForm.ticketHotelStressThree" :maxLength="100"
                       placeholder="请输入商品亮点3"></a-input>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol" prop="ticketHotelStressFour">
              <a-input v-model="ruleForm.ticketHotelStressFour" :maxLength="100"
                       placeholder="请输入商品亮点4"></a-input>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol" prop="ticketHotelStressFives">
              <a-input v-model="ruleForm.ticketHotelStressFives" :maxLength="100"
                       placeholder="请输入商品亮点5"></a-input>
            </a-form-model-item>
            <a-form-model-item label="商品轮播图" prop="proImgs">
              <custom-upload-pro-images v-model="ruleForm.proImgs"
                                        :pro-id="proId" :multiple-selected="true"
                                        :draggableUpdate="true">
              </custom-upload-pro-images>
            </a-form-model-item>
            <a-form-model-item label="关联景点" required>
              <a-button @click="openDialog(1)">选择景点</a-button>
              <div class="tThemeLevelMain">
                <div class="tThemeLevelBtn" v-for="(proItem,proIndex) in proTicketList" :key="proIndex">
                  {{ proItem.proName }}
                  <a-icon @click="handleTicketClose(proIndex)" type="close-circle"/>
                </div>
              </div>
            </a-form-model-item>
            <a-form-model-item label="关联酒店" required>
              <a-button @click="openDialog(2)">选择酒店</a-button>
              <div class="tThemeLevelMain">
                <div class="tThemeLevelBtn" v-for="(proItem,proIndex) in proHotelList" :key="proIndex">
                  {{ proItem.proName }}
                  <a-icon @click="handleHotelClose(proIndex)" type="close-circle"/>
                </div>
              </div>
            </a-form-model-item>
            <a-form-model-item label="图文详情" required>
              <CustomUeditor v-model="ruleForm.proDetailDes"></CustomUeditor>
            </a-form-model-item>
            <a-form-model-item label="预订须知">
              <a-textarea v-model="ruleForm.bookingNeed" :maxLength="500" placeholder="请输入"
                          :auto-size="{minRows:8,maxRows:15}"/>
            </a-form-model-item>
            <a-form-model-item label="发票模板" prop="invoiceTemplateId">
              <InvoiceSelect ref="InvoiceSelect" :proId="proId" :catalogId="catalogId"
                             v-model="ruleForm.invoiceTemplateId"></InvoiceSelect>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
              <a-button type="primary" :disabled="proSource!=0" @click="onSubmit" :loading="submitLoading">
                提交并下一步
              </a-button>
              <!-- <a-button  @click="backEvent" style="margin-left: 10px">保存草稿</a-button> -->
            </a-form-model-item>
          </a-form-model>
        </a-card>
        <selected-product-dialog
          :show="showSelectedDialog"
          ref="pageList"
          :itemNames="['search_proId','search_proName']"
          :query-params="selectedQueryParams"
          :requestPromise="getListPromise"
          row-key="erpProId"
          @close="showSelectedDialog=false"
          :columns="getGoodsColumns()"
        >
          <a-form-item label="商品ID" slot="search_proId" v-bind="currentDialogLayout">
            <a-input v-model="selectedQueryParams.erpProId" style="width: 170px" placeholder="请输入商品ID"></a-input>
          </a-form-item>
          <a-form-item label="商品名称" slot="search_proName" v-bind="currentDialogLayout">
            <a-input v-model="selectedQueryParams.proName" style="width: 170px" placeholder="请输入商品名称"></a-input>
          </a-form-item>
          <template slot="action" slot-scope="rowItem">
            <a-button type="primary" @click="onSelectedResult(rowItem.record)">选择</a-button>
          </template>
        </selected-product-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import ProductHeader from '../components/ProductHeader'
import PublishHelper from '../components/PublishHelper'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import CustomUploadProImages from '@/customComponents/CustomUploadProImages/CustomUploadProImages'
import CustomUeditor from '@/customComponents/CustomUeditor/CustomUeditor'
import InvoiceSelect from '../components/InvoiceSelect'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'

export default {
  name: 'PresellBasicInfo',
  components: {
    ProductHeader,
    PublishHelper,
    CustomUploadProImages,
    CustomUeditor,
    InvoiceSelect,
    SelectedProductDialog
  },
  mixins: [ruleFormMixins],
  data() {
    return {
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      showSelectedDialog: false,
      selectedQueryParams: {
        proName: '',
        erpProId: '',
        proCatalogId: ''
      },
      currentDialogLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      ruleForm: {
        bookingNeed: '',// 预定须知 ,
        erpHotelId: '',// 关联第三方酒店ID ,
        erpTicketId: '',// 关联第三方景点ID集合,多个景点使用逗号(英文)分割 ,
        proDetailDes: '',// 产品详情(商品信息) ,
        proId: this.$route.params.proId,// 产品ID ,
        proImgs: [],// 景酒产品图片 ,
        proName: '',// 产品名称 ,
        ticketHotelStressFives: '',// 产品亮点5 ,
        ticketHotelStressFour: '',// 产品亮点4 ,
        ticketHotelStressOne: '',// 产品亮点1 ,
        ticketHotelStressThree: '',// 产品亮点3 ,
        ticketHotelStressTwo: '',// 产品亮点2
        invoiceTemplateId: undefined//发票
      },
      submitLoading: false,
      submitFormData: '',
      invoiceTemplateList: [],
      invoiceTemplateId: '',//发票ID
      rules: {
        proName: [
          { required: true, message: '请输入商品标题', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入介绍标语', trigger: 'blur' }
        ],
        proImgs: [
          { required: true, message: '请选择图片', trigger: ['blur', 'change'] }
        ],
        invoiceTemplateId: [
          { required: true, message: '请选择发票模板', trigger: 'change' }
        ]
      },
      fileList: [],
      imageList: [],
      proTicketList: [],//景点产品集合
      proHotelList: []//酒店产品集合
    }
  },
  watch: {
    'selectedQueryParams.proCatalogId': {
      handler(val, oldVal) {
        this.getLogUtils().logWithTag('更新商品来源', val)
        this.$nextTick(() => {
          this.$refs.pageList.refresh(true)
        })
      }
    }
  },
  mounted() {
    this.getProductInfo()
  },
  methods: {
    getListPromise(params) {
      return this.getHttpServices().getProService().post('product/info/getConnProInfoPage', params)
    },
    //打开产品弹窗
    openDialog(type) {
      this.showSelectedDialog = true
      if (this.selectedQueryParams.proCatalogId != type) {
        this.selectedQueryParams.proName = ''
        this.selectedQueryParams.erpProId = ''
      }
      this.selectedQueryParams.proCatalogId = type
    },
    getGoodsColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'erpProId',
          width: '100px'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '省份',
          dataIndex: 'provinceName'
        },
        {
          title: '城市',
          dataIndex: 'cityName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    onSelectedResult(obj) {
      if (this.selectedQueryParams.proCatalogId == 1) {
        if (this.proTicketList.length > 0) {
          let flag = false
          this.proTicketList.map((item) => {
            if (item.erpProId == obj.erpProId) {
              this.$message.error('请勿重复添加景点产品')
              flag = true
            }
          })
          if (!flag) {
            this.proTicketList.push(obj)
            this.showSelectedDialog = false
          }
        } else {
          this.proTicketList.push(obj)
          this.showSelectedDialog = false
        }
      } else if (this.selectedQueryParams.proCatalogId == 2) {//酒店只能一个
        if (this.proHotelList.length < 1) {
          this.proHotelList.push(obj)
          this.showSelectedDialog = false
        } else {
          this.$message.error('最多添加一个添加酒店产品')
        }
      }
      console.error(this.proHotelList)
    },
    handleTicketClose(index) {
      this.getLogUtils().logWithTag('handleTicketClose', index)
      if (this.proTicketList.length > 0) {
        this.proTicketList.splice(index, 1)
      }
    },
    handleHotelClose(index) {
      this.getLogUtils().logWithTag('handleHotelClose', index)
      if (this.proHotelList.length > 0) {
        this.proHotelList.splice(index, 1)
      }
    },
    checkForm() {
      if (!this.ruleForm.ticketHotelStressOne && !this.ruleForm.ticketHotelStressTwo && !this.ruleForm.ticketHotelStressThree && !this.ruleForm.ticketHotelStressFour && !this.ruleForm.ticketHotelStressFives) {
        this.$message.error('请至少填写一个商品亮点')
        return false
      }
      if (this.proTicketList.length < 1) {
        this.$message.error('请至少添加一个景点')
        return false
      }
      if (this.proHotelList.length < 1) {
        this.$message.error('请至少添加一个酒店')
        return false
      }
      if (!this.ruleForm.proDetailDes) {
        this.$message.error('请输入图文详情')
        return false
      }
      return true
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.checkForm()) {
            this.submitData()
          }
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    // 保存接口
    submitData() {
      this.submitLoading = true
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      let ticketArr = this.proTicketList.map((item) => {
        return item.erpProId
      })
      this.submitFormData.erpTicketId = ticketArr.join(',')
      let hotelArr = this.proHotelList.map((item) => {
        return item.erpProId
      })
      this.submitFormData.erpHotelId = hotelArr.join(',')
      this.submitFormData.proImgs = this.submitFormData.proImgs.length > 0 ? this.submitFormData.proImgs.join(',') : ''
      delete this.submitFormData.erpHotelInfo
      delete this.submitFormData.erpTicketInfo
      this.getHttpServices().getProService().post('product/ticketHotel/editProTicketHotel', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('基本信息保存成功')
        this.ruleForm.proId = res
        this.$router.push({
          name: 'OptionList',
          query: {
            proId: this.ruleForm.proId,
            catalogId: this.catalogId,
            proSource: this.proSource,
            isBack: this.proId == 0 ? 1 : undefined
          }
        })
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 获取基本信息
    getProductInfo() {
      if (this.proId != 0) {
        this.getHttpServices().getProService().post('product/ticketHotel/getProTicketHotel?proId=' + this.proId).then(res => {
          this.getLogUtils().logWithTag('getProductInfo', res)
          this.ruleForm = res
          if (res.erpTicketInfo && res.erpTicketInfo.length > 0) {
            this.proTicketList = res.erpTicketInfo //景点
          }
          if (res.erpHotelInfo && res.erpHotelInfo.length > 0) {
            this.proHotelList = res.erpHotelInfo //酒店
          }
          console.error(this.proHotelList)
          this.ruleForm.proImgs = res.proImgs && res.proImgs != '' ? res.proImgs.split(',') : []
          this.$refs.InvoiceSelect.getMatchTemplateId()
          this.getLogUtils().logWithTag('getProductInfo', this.ruleForm)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      }
    }
  }

}
</script>
<style lang="less" scoped>
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      width: 400px;
      flex-grow: 1;
    }
  }
}

.pt10 {
  padding-top: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.tThemeLevelMain {
  .tThemeLevelBtn {
    display: inline-block;
    margin-right: 15px;
    padding: 0 10px;
    border: 1px #ccc solid;
    border-radius: 5px;
    line-height: 28px;
    font-size: 12px;
    cursor: pointer;
  }

  .tThemeLevelBtn:hover {
    border: 1px #FAAD14 solid;
  }
}
</style>